
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftRight0 as ObiThreewayAcuatorGenericInleftRight0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-right-0.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftRight0 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-right-0',
   elementClass: ObiThreewayAcuatorGenericInleftRight0Element,
   events: {
     
   }
  });
 
 